import { Routes, Route, Navigate } from "react-router-dom";
import { LoginPage } from "../pages/LoginPage";
import { ServicesPage } from "../pages/ServicesPage";
import { ServiceDetailsPage } from "../pages/ServiceDetailsPage";
import { EnvironmentPage } from "../pages/EnvironmentPage";
import { SettingsPage } from "../pages/SettingsPage";
import { AdminUsersPage } from "../pages/admin/AdminUsersPage";
import { AdminKeycloakPage } from "../pages/admin/AdminKeycloakPage";
import { AdminSettingsPage } from "../pages/admin/AdminSettingsPage";
import { AdminGitHubAccessRequestsPage } from "../pages/admin/AdminGitHubAccessRequestsPage";
import { AdminAccessRequestsPage } from "../pages/admin/AdminAccessRequestsPage";
import { GitHubAccessPage } from "../pages/GitHubAccessPage";
import { DeploymentsPage } from "../pages/DeploymentsPage";
import { HeraldTasksPage } from "../pages/HeraldTasksPage";
import { FilesPage } from "../pages/FilesPage";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { useAuth } from "../contexts/AuthContext";
import { AdminRoute } from "./AdminRoute";
import { SuperuserRoute } from "./SuperuserRoute";

export function AppRoutes() {
  const { user } = useAuth();

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Navigate to="/services" replace />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:serviceId" element={<ServiceDetailsPage />} />
        <Route
          path="/services/:serviceId/environments/:envId"
          element={<EnvironmentPage />}
        />
        <Route path="/github-access" element={<GitHubAccessPage />} />
        <Route path="/deployments" element={<DeploymentsPage />} />
        <Route path="/herald" element={<HeraldTasksPage />} />
        <Route path="/files" element={<FilesPage />} />
        <Route path="/files/api-keys" element={<FilesPage />} />
        <Route path="/settings" element={<SettingsPage />} />

        {/* Admin Routes - gated by role (ADMIN / SUPERUSER) */}
        <Route element={<AdminRoute />}>
          <Route
            path="admin/github-access-requests"
            element={<AdminGitHubAccessRequestsPage />}
          />
          <Route path="admin/users" element={<AdminUsersPage />} />
          <Route
            path="admin/access-requests"
            element={<AdminAccessRequestsPage />}
          />
          <Route path="admin/system-settings" element={<AdminSettingsPage />} />
        </Route>

        {/* Superuser-only Routes */}
        <Route element={<SuperuserRoute />}>
          <Route path="admin/keycloak" element={<AdminKeycloakPage />} />
        </Route>

        {/* Legacy Admin Routes - Redirect to admin mode routes */}
        <Route element={<AdminRoute />}>
          <Route
            path="/users"
            element={<Navigate to="/admin/users" replace />}
          />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/services" replace />} />
    </Routes>
  );
}
